import React from "react"
import './index.css';
import Helmet from "react-helmet";
import PageLayout from './page';
import loadJS from '../utils/load-js';
require('prismjs/themes/prism-okaidia.css')


// At this point, gatsby 1.0 does not support more than one layout, so we implement
// this here.
class SwitchingLayout extends React.Component {
  render() {
    const { location, children } = this.props;

    const locationsWithoutLayout = ['', '/android', '/index']
    let {pathname} = location;
    if (pathname[pathname.length-1] == '/') {
      pathname = pathname.slice(0, -1);
    }
    let LayoutComponent;
    if (locationsWithoutLayout.indexOf(pathname) > -1) {
      LayoutComponent = null;
    }
    else {
      LayoutComponent = PageLayout;
    }

    if (LayoutComponent) {
      return <LayoutComponent {...this.props} />
    }

    return (
      <div>
        <Helmet
          titleTemplate="%s - BundleCop"
          defaultTitle="BundleCop"
        >
          <meta
            name="description"
            content="Helps developers to keep an eye on their app size. Useful for web apps, and all applications."
          />
          <meta name="keywords" content="webpack,file size,bundle size,app size,analyze, output size, chunk size" />
        </Helmet>
        {children()}
      </div>
    )
  }

  componentWillMount() {
    if (typeof window === 'undefined') {
      return;
    }

    window.Geumja = window.Geumja || [];
    window.Geumja.push(['set', {
      wid: 'a02430a5-af0d-436c-a0b2-46f8f81dc9f1',
      color: 'rgb(93, 111, 210)'
    }]);
    Geumja.push(['addTrigger', {
      position: { bottom: 20, right: 50 }
    }]);

    loadJS('https://feedbackwidget.io/js');
  }
}

SwitchingLayout.propTypes = {
  children: React.PropTypes.func,
  location: React.PropTypes.object,
  route: React.PropTypes.object,
}

export default SwitchingLayout;



// WEBPACK FOOTER //
// ./src/layouts/index.js